import React from "react";
import Image from "react-bootstrap/Image";
import UploadPhoto from "site_media/images/default-profile-pic-feeds.png";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";

class CoverBanner extends React.Component {
  render() {
    return (
      <div className="banner" style={{ width: "100%" }}>
        <div
          className="banner-img-back"
          style={{
            backgroundImage: `url(${this.props.cover || MyDefaultCoverPhoto})`,
          }}
        ></div>
        <Image
          className="profilePic"
          src={this.props.profile || UploadPhoto}
          style={{ position: "static", marginTop: "-90px" }}
        />
      </div>
    );
  }
}

export default CoverBanner;
